import { generatePath } from "react-router-dom";
import { SUBSCRIPTION } from "../apiEndPoints";
import { api, convertKeysToCamelCase } from "./api";

export const subscriptionApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.query({
      query: ({ accountId }) => ({
        url: generatePath(SUBSCRIPTION, { accountId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
    }),
  }),
});

export const { useGetSubscriptionQuery } = subscriptionApiSlice;
